import React from 'react'
import Header from '../../../component/layout/header'
import { Outlet } from 'react-router'
import useNav from '../../../component/custom-hooks/get-nav'

const OfficeAssetSummaryLayout = () => {
  const navList = useNav();
  let { officeAssetsSummaryBottom, officeAssetsTopHeader } = navList;
  return (
    <div className="webBody">
      <Header bottomTabs={officeAssetsSummaryBottom} topTabs={officeAssetsTopHeader} />
      <Outlet />
    </div>
  )
}

export default OfficeAssetSummaryLayout